import { DataChartsStateRate } from '../../../interfaces/truckLoadRateServiceInterfaces';
import {
    STATE_RATE_HISTORY_REQUEST,
    STATE_RATE_HISTORY_SUCCESS,
    STATE_RATE_HISTORY_FAILURE
} from '../../actions/truckLoadRate/stateRateActions';

interface StateRateCharts {
    isFetchingStateRateCharts: boolean;
    stateRateChartData: DataChartsStateRate;
}

const fetchStateRateChartsReducer = (stateRateCharts: StateRateCharts = {
    isFetchingStateRateCharts: false,
    stateRateChartData: {} as DataChartsStateRate
}, action: any): StateRateCharts => {
    switch (action.type) {
        case STATE_RATE_HISTORY_REQUEST: {
            return {
                ...stateRateCharts,
                isFetchingStateRateCharts: true
            };
        }
        case STATE_RATE_HISTORY_SUCCESS: {
            return {
                isFetchingStateRateCharts: false,
                stateRateChartData: action.payload
            };
        }
        case STATE_RATE_HISTORY_FAILURE: {
            return {
                isFetchingStateRateCharts: false,
                stateRateChartData: {} as DataChartsStateRate
            };
        }
        default:
            return stateRateCharts;
    }
};

export default fetchStateRateChartsReducer;
